import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../context/CurrentUserContext";
import { levelContentData, docBaseUrl as pdfBaseUrl } from "../LevelContentData";
import { readerDocsData } from "../readerData";
import { getAccessibleLevels } from "../../../utils/accessibleLevels";
import { slugify, slugToText } from "../../../utils/slugify";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { useLanguage } from "../../../context/LanguageContext.js";
import { useTranslation } from "../../../utils/hooks/translateHook.js";  
import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook.js";


import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./ReaderHome.css";

/* const REACT_APP_API_URL = process.env.REACT_APP_API_URL;    */
/* console.log("Reader HomeAlone:" , process.env.REACT_APP_API_URL) */

export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL
console.log("Fetching bookmarks from:", `${API_URL}/bookmarks`);

const useJumpPlugin = () => {
  const jumpRef = useRef(null);
  return {
    jumpToRef: jumpRef,
    plugin: {
      install: (pluginFunctions) => {
        jumpRef.current = pluginFunctions.jumpToPage;
      },
      uninstall: () => {
        jumpRef.current = null;
      },
    },
  };
};


const ReaderHome = ({ user }) => {
  const { currentUser } = useContext(CurrentUserContext);
  const { pdfSlug } = useParams();
  const pdfUrl = `${pdfBaseUrl}${pdfSlug}.pdf`;

  const [pdfReady, setPdfReady] = useState(false);
  const [note, setNote] = useState("");
  const [openSubjectIndex, setOpenSubjectIndex] = useState(null);
  const navigate = useNavigate();
  const [openBook, setOpenBook] = useState(null);
  const [bookmarks, setBookmarks] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const t = useTranslation();

  const accessibleLevels = getAccessibleLevels(user);

  const currentDoc = readerDocsData.find(doc => doc.slug === pdfSlug);

  /*   const defaultPluginInstance = defaultLayoutPlugin();
      const { Toolbar } = defaultPluginInstance;
  */
  const defaultPluginInstance = defaultLayoutPlugin({
      sidebarTabs: () => [],
      renderToolbar: (Toolbar) => (
          <Toolbar>
              {(slots) => (
                  <div className="pdf-toolbar-wrapper">
                      {slots.GoToPreviousPage && slots.GoToPreviousPage()}
                      {slots.CurrentPageInput && slots.CurrentPageInput()}
                      {slots.GoToNextPage && slots.GoToNextPage()}
                      {slots.ZoomOut && slots.ZoomOut()}
                      {slots.Zoom && slots.Zoom()}
                      {slots.ZoomIn && slots.ZoomIn()}
                      {slots.Print && slots.Print()}
                      {/*  {slots.Download && slots.Download()} */}
                      {/* {slots.Search && React.isValidElement(<slots.Search />) ? <slots.Search /> : null} */}
                      {/* You can add/remove slots as you wish */}
                  </div>
              )}
          </Toolbar>
      ),
  });

  const { jumpToRef, plugin: jumpPlugin } = useJumpPlugin();
  const plugins = [defaultPluginInstance, jumpPlugin];


    const handleAddBookmark = () => {
      if (!bookmarks.includes(currentPage)) {
        const updated = [...bookmarks, currentPage].slice(-5); // Keep only last 3 testi kebaps
        setBookmarks(updated);

        fetch(`${API_URL}/bookmarks/${pdfSlug}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ pages: updated }),
        }).catch((err) => console.error("Failed to save bookmarks", err));
      }
    };

    useEffect(() => {
      if (pdfSlug) {
        fetch(`${API_URL}/bookmarks/${pdfSlug}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
          .then((res) => res.json())
          .then((data) => setBookmarks(data.pages || []));
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pdfSlug]);

    const jumpTo = (pageIndex) => {
      if (jumpToRef.current) {
        jumpToRef.current(pageIndex);
      } else {
        console.warn("jumpToPage not available yet");
      }
    };

    const handleSaveNote = () => {
      fetch(`${API_URL}/notes/${pdfSlug}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ content: note }),
      }).then(() => alert("Note saved!"));
    };

    useEffect(() => {
      if (pdfSlug) {
          fetch(`${API_URL}/notes/${pdfSlug}`, {
              headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
          })
              .then(res => res.json())
              .then(data => {
                  setNote(data?.content || "");
              })
              .catch(() => setNote(""));
      }
  } , [pdfSlug]);


    const handleDownloadNote = () => {
      const element = document.createElement("a");
      const file = new Blob([note], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = `${slugToText(pdfSlug)}-note.txt`;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    };

    return (
      <div className="layout">
        <div className="doc-page">
          <div className="doc-content">
            <aside className="sidebar">
              <div className="user-profile">
                <img className="profile-pic" src={`${currentUser.profilePicture}`} />
                <h3>{t('greeting')} {currentUser?.name} !</h3>
              </div>

                <div className="map-container">
                  <div className="ebook-list-box" >
                    {readerDocsData.map(doc => (
                      <div key={doc.slug} style={{ marginBottom: 10 }}>
                        <button className="sidetitle"
                          style={{ display: "block", color: openBook === doc.slug ? "#517ab7 " : "#222", marginBottom: "6px", paddingBottom: "4px", textAlign: "start" }}
                          onClick={() => {
                            setOpenBook(openBook === doc.slug ? null : doc.slug)
                            if (pdfSlug !== doc.slug) navigate(`/docs/${doc.slug}`);
                          }}>
                            {doc.title}
                        </button>
                        
                        {/* Only show mini-titles (not title!) if this book is selected */}
                        {openBook === doc.slug && doc.miniTitles && doc.miniTitles.length > 0 && (
                          <div className="ebook-list-open" >
                            {doc.miniTitles.map((mini, idx) => (
                              <button key={mini.title} onClick={() => jumpTo(mini.page)} className="button sidebutton" style={{backgroundColor:"white"}} >
                                {mini.title}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
            </aside>

          <main className="doc-main">
            {!user ? (
                <div>Loading...</div>
              ) : pdfSlug ?  (
              <>
                <div className="doc-box">
                  <div className="pdf-wrapper">
                    <div>
                      <button className="add-bookmark-button" onClick={handleAddBookmark}>
                        🔖 {t('addBookmark')}
                      </button>
                      <ul className="bookmark-buttons">
                        {!pdfReady ? (
                          <li style={{ opacity: 0.5 }}>📄 {t('loadingBookmarks')}</li>
                        ) : bookmarks.length > 0 ? (
                          bookmarks.map((page, idx) => (
                            <li key={`bookmark-${page}`}>
                              <button onClick={() => jumpTo(page)}>Page {page + 1}</button>
                            </li>
                          ))
                        ) : (
                          <li style={{ opacity: 0.5 }}>📭 {t('noBookmarks')}</li>
                        )}
                      </ul>
                    </div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={pdfUrl}
                        plugins={[defaultPluginInstance, jumpPlugin]}
                        onPageChange={(e) => setCurrentPage(e.currentPage)}
                        onDocumentLoad={() => setPdfReady(true)}
                      />
                    </Worker>
                  </div>
                </div>

                <div className="notes-section">
                  <p>
                    <strong>{t('ebookName')} </strong>
                    {slugToText(pdfSlug).toUpperCase()}
                  </p>
                  <div className="note-layout">
                    <div className="note-buttons">
                      <button className="save-button" onClick={handleSaveNote}>
                        {t('save')}
                      </button>
                      <button className="download-button" onClick={handleDownloadNote}>
                        {t('download')}
                      </button>
                    </div>
                    <textarea
                      className="note-input"
                      placeholder="Write your notes here..."
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="layout">
                <div className="landingImageDiv" >
                  <div className="landingImage-containerbubble">
                    <div className="landingImage-bubble">
                      {t('ebookBubble')}
                      <span>{t('ebookQuotedFrom')}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </main>

          </div>
        </div>
      </div>
    );
};

export default ReaderHome;
